import useSWR from 'swr';
import { useMemo } from 'react';

import axiosInstance, { endpoints, fetcher } from 'src/lib/axios';
import { IÄrende } from "../types/nya/ärendenNy";
import { IAnvändare } from "../types/nya/common";

// ----------------------------------------------------------------------

const swrOptions = {
  revalidateIfStale: false,
  revalidateOnFocus: false,
  revalidateOnReconnect: false,
};

// ----------------------------------------------------------------------

export function useGetAnvändare() {
  const url = endpoints.användare.root;

  const { data, isLoading, error, isValidating } = useSWR<IAnvändare>(url, fetcher, swrOptions);

  const memoizedValue = useMemo(
    () => ({
      anvandare: data || null,
      anvandareLoading: isLoading,
      anvandareError: error,
      anvandareValidating: isValidating,
      ärendenEmpty: !isLoading && !data,
    }),
    [data, error, isLoading, isValidating]
  );

  return memoizedValue;
}

// ----------------------------------------------------------------------

type ÄrendeData = {
  ärende: IÄrende;
};

export function useGetÄrende(id: string) {
  // const url = endpoints.ärende.details;
  const url = id ? endpoints.ärende.details + id : '';

  const { data, isLoading, error, isValidating } = useSWR<ÄrendeData>(url, fetcher, swrOptions);

  const memoizedValue = useMemo(
    () => ({
      ärende: data,
      ärendeLoading: isLoading,
      ärendeError: error,
      ärendeValidating: isValidating,
    }),
    [data?.ärende, error, isLoading, isValidating]
  );

  return memoizedValue;
}

// ----------------------------------------------------------------------

export async function updateAnvändare(anvandare: IAnvändare) {
  const url = endpoints.användare.root;
  try {
    const response = await axiosInstance.put(url, anvandare);
    return response.data;
  } catch (error) {
    console.error('Failed to update user', error);
    throw error;
  }
}

export async function laddaUppAvatar(file: File) {
  const url = endpoints.användare.laddaUppAvatar;
  const formData = new FormData();
  formData.append('fil', file);

  try {
    const response = await axiosInstance.post(url, formData, {
      headers: { 'Content-Type': 'multipart/form-data' }
    });
    return response.data;
  } catch (error) {
    console.error('Failed to upload avatar', error);
    throw error;
  }
}

export async function raderaKonto() {
  const url = endpoints.användare.root;
  try {
    const response = await axiosInstance.delete(url);
    return response.data;
  } catch (error) {
    console.error('Failed to delete account', error);
    throw error;
  }
}
